import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { FaTimes } from "react-icons/fa";

const ViewBioData = ({ show = true, handleClose }) => {
  const location = useLocation();
  const bioData = location.state?.bioDataProbs || {};
  const navigate = useNavigate();

  const closeHandler = handleClose || (() => navigate("/bio-data-table"));

  const renderDescription = (text) => {
    const isLink = /^https?:\/\/|www\.|\.com\b/.test(text);
    return isLink ? (
      <a
        href={text.startsWith("http") ? text : `https://${text}`}
        className="text-primary text-decoration-underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    ) : (
      <p style={{ color: "black", margin: "5px 0" }}>{text}</p>
    );
  };

  if (!show) return null;

  return (
    <div
      className="modal-overlay bio_data_view  admin_modal_preview"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.3)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        className="custom-modal-content"
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "20px",
          width: "100%",
          maxWidth: "700px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
        }}
      >
        <form className="m-0">
          <div className="modal_preview_title text-left">
            <h2 className="pb-3 m-auto ps-0">Board Member Preview</h2>
          </div>
          <div className="custom-form-group d-block closepreview text-right">
            <button
              type="button"
              className="custom-btn-cancel"
              onClick={closeHandler}
            >
              <FaTimes />
            </button>
          </div>

          {bioData.imagePath && (
            <div className="custom-form-group modalimage mb-2">
              <label className="custom-label">Image</label>
              <span>:</span>
              <div
                className="modal_preview_img"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <img src={bioData.imagePath} alt="Preview" />
              </div>
            </div>
          )}

          <div className="custom-form-group mb-2">
            <label className="custom-label">Member Name</label>
            <span>:</span>
            <h5 style={{ margin: "5px 0" }}>{bioData.memberName}</h5>
          </div>

          <div className="custom-form-group">
            <label className="custom-label">Organization Name</label>
            <span>:</span>
            <p style={{ margin: "5px 0" }}>{bioData.organizationName}</p>
          </div>

          <div className="custom-form-group">
            <label className="custom-label">Designation</label>
            <span>:</span>
            <h5 style={{ margin: "5px 0" }}>{bioData.designation}</h5>
          </div>

          <div className="custom-form-group">
            <label className="custom-label">Address</label>
            <span>:</span>
            <p style={{ margin: "5px 0" }}>
              {bioData.address || bioData.location}
            </p>
          </div>

          <div className="custom-form-group">
            <label className="custom-label">Experience</label>
            <span>:</span>
            <p style={{ margin: "5px 0" }}>
              {bioData.experience || bioData.experiance}
            </p>
          </div>

          {Array.isArray(bioData.energyFields) &&
            bioData.energyFields.map((energy, index) => (
              <div key={index} style={{ marginBottom: "15px" }}>
                <div className="custom-form-group">
                  <label className="custom-label">
                    Energy Title {index + 1}
                  </label>
                  <span>:</span>
                  <h5 style={{ color: "black", margin: "5px 0" }}>
                    {energy.energyTitle}
                  </h5>
                </div>

                <div className="custom-form-group">
                  <label className="custom-label">
                    Energy SubTitle {index + 1}
                  </label>
                  <span>:</span>
                  <h5 style={{ color: "black", margin: "5px 0" }}>
                    {energy.energySubTitle}
                  </h5>
                </div>

                <div className="custom-form-group">
                  <label className="custom-label">
                    Energy Description {index + 1}
                  </label>
                  <span>:</span>
                  {renderDescription(energy.energyDescription)}
                </div>

                {Array.isArray(energy.additionalFields) &&
                  energy.additionalFields.map((field, addIndex) => {
                    const isLink = /^https?:\/\/|www\.|\.com\b/.test(
                      field.value
                    );
                    let parsedList = [];

                    if (field.type === "list") {
                      parsedList = Array.isArray(field.value)
                        ? field.value
                        : (() => {
                            try {
                              return JSON.parse(field.value);
                            } catch {
                              return [];
                            }
                          })();
                    }

                    return (
                      <div key={addIndex} className="mt-2 custom-form-group">
                        {field.type === "paragraph" && (
                          <p style={{ marginBottom: "5px" }}>{field.value}</p>
                        )}

                        {field.type === "text" &&
                          (isLink ? (
                            <a
                              href={
                                field.value.startsWith("http")
                                  ? field.value
                                  : `https://${field.value}`
                              }
                              className="text-primary text-decoration-underline d-block"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {field.value}
                            </a>
                          ) : (
                            <p style={{ marginBottom: "5px" }}>{field.value}</p>
                          ))}

                        {field.type === "list" && parsedList.length > 0 && (
                          <ul style={{ margin: "0", paddingLeft: "20px" }}>
                            {parsedList.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        )}
                        {field.type === "link" && (
                          <a
                            href={field.linkURL}
                            className="text-primary text-decoration-underline d-block"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {field.linkText}
                          </a>
                        )}
                      </div>
                    );
                  })}

                <hr style={{ borderTop: "1px dashed #ccc" }} />
              </div>
            ))}
        </form>
      </div>
    </div>
  );
};

export default ViewBioData;
